
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1709"}},[_c('path',{attrs:{"data-name":"Rectangle 2411","fill":"none","d":"M.001 0h25v20h-25z"}}),_c('g',{attrs:{"data-name":"Group 1708","fill":"#3c3c3c"}},[_c('path',{attrs:{"data-name":"Path 1059","d":"M20 8.434a2.5 2.5 0 102.5 2.5 2.5 2.5 0 00-2.5-2.5z"}}),_c('path',{attrs:{"data-name":"Path 1060","d":"M16 0H9a1 1 0 00-1 1v11H6.5a4 4 0 100 8h5a4 4 0 100-8H10V6h6a1 1 0 001-1V1a1 1 0 00-1-1zm-4.5 14a2 2 0 110 4h-5a2 2 0 110-4H8v1a1 1 0 002 0v-1z"}})])])])
          )
        }
      }
    